import Vue from 'vue';
import { getVueI18n } from '../../../shared/services/I18nService';
import { createId } from '../../../shared/util';
import us from '../defines';
import { makeObservable } from '../../../shared/stores/core/make-observable';
import { memoize } from 'lodash';

/**
 * Creates a viewport "overlay" extension constructor that can be passed to the uScope plugin API.
 * @param components
 * @param layoutOptions
 * @param hiddenNavModes
 * @returns {function(*, *, ...[*]): Vue}
 */
export function makeOverlayExtension ({ components, layoutOptions, hiddenNavModes = {} }) {
  return function (uScope, viewport, ...dependencies) {
    viewport.overLayout.add(layoutOptions);
    const vpStatus = makeVpStatus(viewport.eventNameSpaceGet(), viewport.getImageIdx());
    const jVpDiv = viewport.vpDivGet('outer');
    const { div, id } = makeDiv(layoutOptions.divClass);
    jVpDiv.append(div);
    us.setAnnotNavModes(hiddenNavModes);

    return new Vue({
      el: `#${id}`,
      i18n: getVueI18n(),
      render: h => h(Object.values(components)[0], {
        props: {
          layoutOptions,
          vpStatus,
          viewport,
          hiddenNavModes,
          dependencies
        }
      }),
      components
    });
  };
}

export const viewportOverlayMixin = {
  props: {
    viewport: {
      type: Object,
      required: true
    },
    vpStatus: {
      type: Object,
      required: true
    },
    layoutOptions: {
      type: Object,
      required: true
    },
    hiddenNavModes: {
      type: Object, // This should be an array but legacy compat...
      required: true
    },
    dependencies: {
      type: Array,
      required: true
    }
  },
  computed: {
    userPrefs () {
      return this.dependencies[0].prefs;
    },
    isVisible () {
      let pref = this.userPrefs[this.layoutOptions.divClass];
      pref = pref ? pref.value : true;
      return this.vpStatus.isActive && pref && !this.hiddenNavModes[this.vpStatus.navMode];
    }
  },
  methods: {
    reLayout () {
      this.viewport.overLayout.refreshPrecinct(this.layoutOptions.precinct);
    }
  },
  watch: {
    isVisible () {
      // relayout after Vue has had a chance to update the DOM
      this.$nextTick(this.reLayout);
    }
  },
  mounted () {
    this.reLayout();
  }
};

// exported for testing; you should use the makeOverlayExtension method above
export const makeVpStatus = memoize((namespace, index) => {
  const vpStatus = makeObservable({
    isActive: false,
    navMode: us.eNavModes.nmNone
  });

  $(us.idHashROOT).on(us.evMODECHANGE + namespace, (e, parms) => {
    vpStatus.navMode = parms.navMode;
  });
  $(us.idHashROOT).on(us.evIMAGESELECTED + namespace, (e, parms) => {
    vpStatus.isActive = (parms.uScopeIdx === index);
  });

  return vpStatus;
});

function makeDiv (divClass) {
  const id = createId();
  const div = document.createElement('div');
  div.setAttribute('id', id);
  div.classList.add(divClass);
  return { div, id };
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/viewport-overlay.js